<div style="  padding: 1px;  justify-content: right;align-items: center;gap: 8px;display: flex;">
  <button (click)="print()"
  class="button-stepper-allow"
 
  mat-stroked-button 
  class="button-stepper-print"
>PRINT<mat-icon >print</mat-icon>
</button>
  </div>

<mat-card appearance="outlined">
  <mat-card-content class="agreements__scrollable">
    <div class="agreements__content">
      <p class="agreements__text agreements__text--title">
        Timely Tax Payments and Associated Penalties.
      </p>
      <p class="agreements__text">
        Taxes are due to the department on the first day of the succeeding month
        and become delinquent on the 21st day of such month. All returns
        postmarked after the
        <strong>20th day of the month are delinquent</strong>. Delinquent
        payments incur a penalty of <strong>10%</strong> or
        <strong>(minimum $50.00)</strong> plus interest.
      </p>
      <p class="agreements__text">
        You may take a collection allowance of <strong>2.5%</strong> of the tax
        <strong>($30 maximum)</strong> if you file on time and remit online
        only.
      </p>
      <p class="agreements__text">
        You are required to keep complete and accurate records, including copies
        of all lease or rental agreements, duplicate copies of receipts issued
        for the payment of rental charges or room rate, any exemption
        certificates, and any pertinent documents. These records
        <strong
          >should be available during business hours for inspection by the tax
          collector or authorized representative of the tax collector’s
          office</strong
        >. In addition, you must preserve these records for at least three
        years.
      </p>
      <p class="agreements__text">
        Please note that any person who is required to collect, truthfully
        account for, and pay any tax and willfully fails to do so shall be
        liable for penalties under the provisions of Section 213.29 Florida
        Statute (FS). All information provided by the applicant is confidential
        as provided in section 213.053 FS and is not subject to Florida Public
        Records Law, Section 119.07 FS.
      </p>
      <p class="agreements__text agreements__text--title">
        Electronic Communication and Signatures Consent
      </p>
      <p class="agreements__text">
        By proceeding with this online application process, you understand and
        agree that the County Tax Collector’s Office (“Tax Collector”)
        may communicate with you regarding this application or other Tourist Tax
        matters electronically, both now and in the future. You further consent
        and agree that by doing so we may choose to provide such communications
        or other documents in electronic format only, through our online system
        or to the email address provided to the Tax Collector by you. Moreover,
        unless and until such consent is withdrawn, you agree that applications,
        agreements, notices, and other documents provided or made available to
        you may be executed electronically and that such electronic signatures
        shall be deemed to have the same legal effect as if such were signed in
        wet ink in accordance with the Electronic Signatures in Global and
        National Commerce Act (“E-Sign Act”), Title 15, United States Code,
        Sections 7001 et seq., and the Uniform Electronic Transaction Act
        (“UETA”), as the same has been implemented in the State of Florida.
      </p>
      <p class="agreements__text">
        In order to ensure proper and timely delivery of communications and
        other documents and information, it is your responsibility to ensure
        that the Tax Collector has a valid email address for you at all times.
        You further acknowledge that by consenting to electronic delivery, you
        have the ability to retain such communications and other documents.
        Should you fail to update or change incorrect information or an invalid
        email address or other contact information, you understand and agree
        that nevertheless any communications, documents, or other information
        provided to you via the email address the Tax Collector has been
        provided will be deemed to have been delivered to you.
      </p>
    </div>
  </mat-card-content>
</mat-card>

<form [formGroup]="agreements">
  <div class="agreements__row margin-top">
    <mat-checkbox
      formControlName="confirmRead"
      color="primary"
      class="agreements__checkbox"
    >
      Check here to confirm you have read, understand and acknowledge the
      reminders posted above
    </mat-checkbox>
  </div>
  <div class="agreements__row">
    <mat-checkbox
      formControlName="confirmAllInformation"
      color="primary"
      class="agreements__checkbox"
    >
      Check here to confirm all information provided on this form is accurate
      and complete.
    </mat-checkbox>
  </div>
  <div class="agreements__row">
    <div class="agreements__col agreements__col--half">
      <mat-form-field
        class="agreements__form-field"
        appearance="outline"
      >
        <mat-label>Printed Name / eSignature</mat-label>
        <input
          formControlName="printedName"
          matInput
          placeholder="Printed Name"
        />
        <mat-error>Printed Name is required</mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="agreements__row">
    <div class="agreements__info">
      <mat-icon>info_outline</mat-icon> If you have any additional questions,
      please contact the Tourist Tax Department at {{ (branding$ | async)?.phone }}
    </div>
  </div>
</form>
<!-- 
<div
  style="height: 302px; overflow-y: scroll; padding-bottom: 0.5rem"
  class="row"
>
  <mat-card appearance="outlined">
    <mat-card-content>
      <div class="agreements__content">
        <p class="agreements__text agreements__text--title">
          Timely Tax Payments and Associated Penalties.
        </p>
        <p class="agreements__text">
          Taxes are due to the department on the first day of the succeeding
          month and become delinquent on the 21st day of such month. All returns
          postmarked after the
          <strong>20th day of the month are delinquent</strong>. Delinquent
          payments incur a penalty of <strong>10%</strong> or
          <strong>(minimum $50.00)</strong> plus interest.
        </p>
        <p class="agreements__text">
          You may take a collection allowance of <strong>2.5%</strong> of the
          tax <strong>($30 maximum)</strong> if you file on time and remit
          online only.
        </p>
        <p class="agreements__text">
          You are required to keep complete and accurate records, including
          copies of all lease or rental agreements, duplicate copies of receipts
          issued for the payment of rental charges or room rate, any exemption
          certificates, and any pertinent documents. These records
          <strong
            >should be available during business hours for inspection by the tax
            collector or authorized representative of the tax collector’s
            office</strong
          >. In addition, you must preserve these records for at least three
          years.
        </p>
        <p class="agreements__text">
          Please note that any person who is required to collect, truthfully
          account for, and pay any tax and willfully fails to do so shall be
          liable for penalties under the provisions of Section 213.29 Florida
          Statute (FS). All information provided by the applicant is
          confidential as provided in section 213.053 FS and is not subject to
          Florida Public Records Law, Section 119.07 FS.
        </p>
        <p class="agreements__text agreements__text--title">
          Electronic Communication and Signatures Consent
        </p>
        <p class="agreements__text">
          By proceeding with this online application process, you understand and
          agree that the County Tax Collector’s Office (“Tax Collector”)
          may communicate with you regarding this application or other Tourist
          Tax matters electronically, both now and in the future. You further
          consent and agree that by doing so we may choose to provide such
          communications or other documents in electronic format only, through
          our online system or to the email address provided to the Tax
          Collector by you. Moreover, unless and until such consent is
          withdrawn, you agree that applications, agreements, notices, and other
          documents provided or made available to you may be executed
          electronically and that such electronic signatures shall be deemed to
          have the same legal effect as if such were signed in wet ink in
          accordance with the Electronic Signatures in Global and National
          Commerce Act (“E-Sign Act”), Title 15, United States Code, Sections
          7001 et seq., and the Uniform Electronic Transaction Act (“UETA”), as
          the same has been implemented in the State of Florida.
        </p>
        <p class="agreements__text">
          In order to ensure proper and timely delivery of communications and
          other documents and information, it is your responsibility to ensure
          that the Tax Collector has a valid email address for you at all times.
          You further acknowledge that by consenting to electronic delivery, you
          have the ability to retain such communications and other documents.
          Should you fail to update or change incorrect information or an
          invalid email address or other contact information, you understand and
          agree that nevertheless any communications, documents, or other
          information provided to you via the email address the Tax Collector
          has been provided will be deemed to have been delivered to you.
        </p>
      </div>
    </mat-card-content>
  </mat-card>
</div>
<form [formGroup]="agreements">
  <div class="row-no-flex">
    <mat-checkbox formControlName="confirmRead" color="primary" class="primary">
      Check here to confirm you have read, understand and acknowledge the
      reminders posted above
    </mat-checkbox>
  </div>
  <div class="row-no-flex">
    <mat-checkbox
      formControlName="confirmAllInformation"
      color="primary"
      class="primary"
    >
      Check here to confirm all information provided on this form is accurate
      and complete.
    </mat-checkbox>
  </div>
  <div class="row">
    <div class="col-6">
      <mat-form-field
        class="mat-form-field-100"
        appearance="outline"
      >
        <mat-label>Printed Name / eSignature</mat-label>
        <input
          formControlName="printedName"
          matInput
          placeholder="Printed Name"
        />
        <mat-error>Printed Name is required</mat-error>
      </mat-form-field>
    </div>

    <div class="row">
      <br />
      <div
        style="
          color: rgba(0, 0, 0, 0.6);
          font-size: 16px;
          font-family: Roboto;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0.15px;
          word-wrap: break-word;
        "
      >
        <mat-icon>info_outline</mat-icon> If you have any additional questions,
        please contact the Putnam County Tax Collector at (386) 329-0282
      </div>
    </div>
  </div>
</form> -->
